import React from 'react';
import CustomLink from '../components/CustomLink';
import { getBillingDays } from './plan-helpers';

const DEFAULT_BILLING_PERIOD_VALUE = 4;

function renderAgreementTerms(subscriptionData, lead, termsOfUseLink, isPeriodInDays = false) {
    const { trialDuration, trial, price, billingPeriod } = subscriptionData;
    const billingPeriodValue = billingPeriod?.value || DEFAULT_BILLING_PERIOD_VALUE;
    const period = isPeriodInDays
        ? `${getBillingDays({ unit: billingPeriod?.unit, value: billingPeriodValue })} days`
        : `${billingPeriodValue} weeks`;

    if (trial) {
        return (
            <>
                {lead}, you agree to automatic subscription
                renewal. First {trialDuration} {trialDuration === 1 ? 'week' : 'weeks'} is {trial.price} now,
                then {price} every {period} until you cancel in settings
                before the end of the current period. Learn more in{' '}
                <CustomLink to={`${termsOfUseLink}#subscription-fees-and-payment`} target='_blank'>
                    Subscription terms
                </CustomLink>
                .
            </>
        );
    }

    return (
        <>
            {lead}, you agree to automatic subscription
            renewal. You will be charged {price} now and every {period} until you cancel in settings
            before the end of the current period. Learn more in{' '}
            <CustomLink to={`${termsOfUseLink}#subscription-fees-and-payment`} target='_blank'>
                Subscription terms
            </CustomLink>
            .
        </>
    );
}

export {
    renderAgreementTerms
};
